var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAnimated(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "grande",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 868.94 866.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GV Real Estate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_negro_copy",
    "data-name": "logo_negro copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sello_copy_3",
    "data-name": "sello copy 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M496.66,65.38,63.53,498.51,496.66,931.64,932.47,498.51ZM87.74,498.51,496.66,89.6l411.6,408.91L496.66,907.42Z",
    transform: "translate(-63.53 -65.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "letra_G_copy_3",
    "data-name": "letra G copy 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "433.13 99.54 150.65 382.01 433.13 667.18 583.78 519.21 497.69 433.13 470.79 433.13 559.57 519.21 433.13 642.96 174.87 382.01 433.13 123.75 694.08 382.01 718.29 382.01 433.13 99.54"
  })), /*#__PURE__*/React.createElement("g", {
    id: "letra_V_copy_3",
    "data-name": "letra V copy 3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "99.54 433.13 433.13 766.72 769.4 433.13 745.19 433.13 433.13 742.5 123.75 433.13 99.54 433.13"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAnimated);
export default __webpack_public_path__ + "static/media/Logo_animated.1a370c3aebd121672ac4d8f9503061b8.svg";
export { ForwardRef as ReactComponent };